/* eslint no-restricted-imports: ["error", { paths: [{
  name: "react-i18next",
  importNames: ["initReactI18next"],
}]}] */

import { createInstance } from 'i18next';
import I18NextIcu from 'i18next-icu';
export var I18N_PLACEHOLDER = '__placeholder__';
export var DEFAULT_LANGUAGE = 'en';
var DEFAULT_RESOURCES = {
  en: {
    translation: {}
  },
  es: {
    translation: {}
  }
};
export function createTranslationsInstance() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? DEFAULT_LANGUAGE : _ref$language,
    _ref$resources = _ref.resources,
    resources = _ref$resources === void 0 ? DEFAULT_RESOURCES : _ref$resources;
  var instance = createInstance({
    defaultNS: 'translation',
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false
    },
    lng: language,
    ns: ['translation', 'glossary', 'common'],
    resources: resources !== null && resources !== void 0 ? resources : DEFAULT_RESOURCES,
    returnNull: false
  });

  /*
   * IMPORTANT NOTE:
   * Don't add `.use(initReactI18next)` as it sets the global
   * instance of react-i18next potentially used by the consuming
   * application.
   *
   * react-i18next relies by order of priority (high to low) on:
   * 1. A i18n instance provided by `I18nContext` (via `I18nextProvider`)
   * 2. A globally available instance set by `initReactI18next`
   *
   * In order to avoid issues with applications consuming the exercises
   * created using `createExercise`, this module relies on its consumer
   * always providing an i18n instance via `I18nextProvider`.
   */
  instance.use(I18NextIcu).init();
  return instance;
}